import Image from '@Components/Utils/Image';
import { FunctionComponent } from 'react';

// Components
import MedicalSpecialty from '@Components/UI/MedicalSpecialy';

// Utils
import classnames from 'classnames';
import { assetMedicalSpecialty } from '@Libs/utils';

// Contexts
import { useViewDetected } from '@Components/Utils/ViewDetected';
import { useDataTransfer } from '@Components/Utils/DataTransfer';

// Styles
import styles from './Specialist.module.scss';

interface SpecialistProps {}

const Specialist: FunctionComponent<SpecialistProps> = () => {
    const { doctor } = useDataTransfer();
    const { deviceType } = useViewDetected();

    const renderSpecialist = () => {
        return doctor?.profile?.medicalSpecialties.map((item, index) => (
            <div key={`item-specialist-${index}`} className={styles.specialist_item}>
                <Image src={assetMedicalSpecialty(item)} className={styles.logo} />
                <span>
                    <MedicalSpecialty code={item} value={'name'} />
                </span>
            </div>
        ));
    };

    const className = classnames([
        styles.wrapper,
        {
            [styles.mobile]: ['mobile', 'tablet'].includes(deviceType),
        },
    ]);

    return (
        <div className={className}>
            <div className={styles.body}>
                <div className={styles.title}>Chuyên khoa</div>
                <div className={styles.specialists}>{renderSpecialist()}</div>
            </div>
        </div>
    );
};

Specialist.defaultProps = {};

export default Specialist;
